import * as React from 'react'



export const AlertTemplate = ({
  options,
  message,
  close,
}) => {
  return (
    <div style={{
  width: "500px",
  padding: "20px",
  fontSize: "80%",
  background: "#243050",
  color: "white",
  display: "flex",
  alignItems: "center",
  fontWeight: "bold",
    }} className={options.type} >
  {options.type==="success"?(
      <span className="fa fa-check mr-2"></span> 
   ):options.type ==="error" ?(
    <span className="fa fa-check text-white mr-2"></span>
  ):null}
      <span className="text-white">{message}</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Alert.js